export default __webpack_public_path__ + "static/media/checkBox.058e9a00.svg";